/**
 * フッターメニュー列: スマホは details で開閉、1000px 以上は常に開く（モックの PC レイアウト）
 */
(function () {
  var mq = window.matchMedia("(min-width: 1000px)");

  function sync() {
    var desktop = mq.matches;
    document.querySelectorAll("details.footer-menu-accordion").forEach(function (el) {
      if (desktop) {
        el.open = true;
      } else {
        el.open = el.hasAttribute("data-footer-column-open");
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", sync);
  } else {
    sync();
  }
  mq.addEventListener("change", sync);
})();
